export default __webpack_public_path__ + "static/media/093-scroll-1.58efa68a.png";